import { OutcomeContent } from 'types/data'
import { isLessonTile } from './isLessonTile'

export const getRankedCourseContent = (outcomeContents: OutcomeContent[]) =>
  outcomeContents
    .filter((content) => !isLessonTile(content))
    .sort(
      (contentA, contentB) => contentB.relevancyScore - contentA.relevancyScore,
    )

export const getRankedLessonContent = (outcomeContents: OutcomeContent[]) =>
  outcomeContents
    .filter((content) => isLessonTile(content))
    .sort(
      (contentA, contentB) => contentB.relevancyScore - contentA.relevancyScore,
    )

export const getRankedContent = (outcomeContents: OutcomeContent[]) => [
  ...getRankedCourseContent(outcomeContents),
  ...getRankedLessonContent(outcomeContents),
]
